import React from "react";
import { Helmet } from "react-helmet";
import MainImage from "../../assets/MainImage.jpg";
import Footer from "../../components/Footer";
import SecondImage from "../../assets/AboutImage4.jpg";
import Navbar from "../../components/NavLite";
import PastWord from "../../components/PastWord";
import SmallTestimony from "../../components/SmallTestimony";

function Austin() {
  return (
    <section>
<Helmet>
  <title>Austin Web Design for Women Entrepreneurs | Woaom Web Design</title>
  <meta
    name="description"
    content="Woaom Web Design creates custom websites for women entrepreneurs in Austin, Texas. Strategic SEO, mobile-first design, and powerful integrations with React, Firebase, and Flodesk."
  />
  <meta
    name="keywords"
    content="Austin web design for women entrepreneurs, Austin TX women-owned business websites, custom websites Austin female founders, Austin SEO web design, Austin startup website design, Austin branding for women-led businesses, Austin professional web design packages, Austin women entrepreneur website agency, Austin TX responsive websites, local SEO Austin business websites, mobile-first websites Austin TX, Austin React developer for women-owned brands, Austin Firebase website expert, Austin Flodesk integration websites, Austin women in tech web design, Austin bespoke web development, strategic web design Austin TX, Austin TX UX/UI design studio, Austin custom-coded websites, Austin conversion-focused web design, professional websites for women entrepreneurs Austin, Austin service business websites, Austin ecommerce websites for women-owned brands, creative studio for Austin women founders, Austin digital strategy and branding, Austin TX high-converting websites, Austin website design for startups, Austin TX modern business websites, Austin women-owned web design agency, elevate your online brand Austin TX"
  />
</Helmet>


      {/* Hero Section */}
      <div
        className="relative h-auto bg-cover bg-center"
        style={{
          clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
          backgroundImage: `url(${MainImage})`,
          padding: "20px",
          width: "100%",
        }}
      >
        <Navbar />
        <div className="p-10">
          <h2 className="text-3xl font-bold uppercase text-black mb-4 text-center">
            <span className="bg-[#CFF098] italic">
              Austin Web Design & SEO for Women Entrepreneurs
            </span>
          </h2>
        </div>
      </div>

      {/* CTA Section */}
      <div className="mx-auto w-full max-w-7xl px-5 py-6 md:px-10 md:py-10 flex flex-col items-center text-center">
        <p className="text-gray-200 mb-4 text-2xl max-w-2xl">
           Based in Austin? We design websites and deliver SEO strategies that
          help women entrepreneurs stand out and grow their brands online.
        </p>
        <a href="https://cal.com/woaomwebdesign/15min">
          <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">
            BOOK A FREE STRATEGY CALL →
          </button>
        </a>
      </div>

{/* Our Process */}
<div className="mx-auto w-full max-w-7xl flex flex-col items-center text-center mt-20">
  <h2 className="text-3xl font-medium md:text-4xl text-white uppercase">
    Our Process
  </h2>
</div>

{/* Centered Paragraph below heading */}
<p className="mx-auto mt-4 max-w-3xl text-sm text-gray-200 sm:text-base md:mb-12 lg:mb-16 text-center">
  We partner with Austin’s women entrepreneurs to create stunning, search-optimized websites—from first concept to final launch.
</p>

<div className="flex flex-col md:flex-row items-stretch gap-8 md:gap-12">
  {/* Text Section */}
  <div className="flex flex-col justify-center w-full md:w-1/2">
    {[
      {
        step: 1,
        title: "Discovery Call",
        desc: "We dive into your goals, your audience, and your unique brand vision to build a strong foundation.",
      },
      {
        step: 2,
        title: "Design & Build",
        desc: "We create a premium, responsive site that speaks to your ideal clients—and converts.",
      },
      {
        step: 3,
        title: "SEO & Strategy",
        desc: "We implement local SEO and keyword strategies to get your business found in Austin and beyond.",
      },
      {
        step: 4,
        title: "Launch & Ongoing Growth",
        desc: "After launch, we support you with ongoing SEO and strategic content to scale your impact.",
      },
    ].map(({ step, title, desc }) => (
      <div key={step} className="mb-8 flex max-w-lg justify-center gap-4 px-6 py-5 text-black">
        <div className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-gray-100">
          <p className="text-sm font-bold sm:text-base">{step}</p>
        </div>
        <div className="ml-4 flex flex-col gap-2">
          <h5 className="text-xl font-medium uppercase text-white">{title}</h5>
          <p className="text-sm text-gray-200">{desc}</p>
        </div>
      </div>
    ))}
  </div>

  {/* Image Section */}
  <div className="w-full md:w-1/2 flex items-stretch">
    <img
      alt="web design for women entrepreneurs, feminine website design, launch-ready website, low tech funnel, no code website template, simple website for coaches, website for mindset coach, 
template for spiritual entrepreneurs, web app for service-based business, women-owned business website"
      src={MainImage}
      className="w-full object-cover"
    />
  </div>
</div>






      {/* Past Work & Testimonials */}
      <PastWord />
      <SmallTestimony />

      {/* About Us Section */}
      <div className="mx-auto w-full">
        <div className="grid gap-6 sm:gap-6 md:grid-cols-2">
          <div className="flex flex-col items-start gap-2 md:py-24 md:px-24 max-w-[600px] p-4">
            <div className="flex items-center rounded-md py-1">
              <p className="text-sm uppercase mb-12">ABOUT US</p>
            </div>
            <h4 className="mb-6 text-2xl font-semibold md:text-3xl md:mb-8 uppercase">
              Empowering{" "}
              <span className="italic text-black bg-[#CFF098]">
                Austin Women Entrepreneurs
              </span>{" "}
              to Build an{" "}
              <span className="italic text-black bg-[#CFF098]">
                Unshakable Online Presence
              </span>
            </h4>
            <p className="text-sm text-white sm:text-xl">
              We specialize in high-end website design and strategic SEO for Austin’s female-led brands. Whether you’re a coach, consultant, or creative, we help you show up like the expert you are—online and in search.
              <br />
              <br />
              With deep local knowledge and a passion for women-owned business success, we bring clarity, conversion, and visibility to every project.
            </p>
            <p className="mt-6 mb-6 text-xl italic uppercase">
              Ready to grow your brand with confidence?{" "}
              <span className="italic">We’re with you every step.</span>
            </p>

            <div className="flex flex-col gap-4 font-regular sm:flex-row">
              <a
                href="/about"
                className="flex rounded-full items-center gap-4 bg-[#CFF098] px-8 py-2 text-black hover:opacity-60 text-sm"
              >
                <p>LEARN MORE ABOUT US →</p>
              </a>
            </div>
          </div>

          <div className="relative w-full h-[]">
            <img
              src={SecondImage}
              alt="website template for coaches, feminine website template, React website template for service providers, sales page template, course website template, booking website template, Kajabi alternative, custom coded website, React Firebase landing page, website template for wellness brand"
              className="absolute top-0 right-0 w-auto h-full object-cover"
            />
          </div>
        </div>
      </div>

      <Footer />
    </section>
  );
}

export default Austin;
